import { render, staticRenderFns } from "./ApiDataLoader.vue?vue&type=template&id=524ea5e8&"
import script from "./ApiDataLoader.vue?vue&type=script&lang=js&"
export * from "./ApiDataLoader.vue?vue&type=script&lang=js&"
import style0 from "./ApiDataLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardTitle,VProgressCircular})
